import styled from 'styled-components';
import { Link } from 'react-router';

export const NavLink = styled(Link)`
text-decoration: none;
color: #1976d2;
`;
export const ProjectContainer = styled.div`

position: fixed;
width: 400px;
top: 120px;
right: 60px;
background: #e9e9e9;
border-radius: 4px;
`
export const ProjectTitle = styled.div`
font-style: normal;
font-weight: 500;
font-size: 24px;
line-height: 29px;
color: #000000;
`
export const EditIcon = styled.div`
display:none;
cursor:pointer;
`
export const HeaderContainer = styled.div`
padding: 32px 32px 0px 32px ;
`
export const ListContainer = styled.div`
max-height: calc(100vh - 300px);
overflow-y: auto;
overflow-x: hidden;
padding: 0px 32px 32px 32px;
`
export const ListView = styled.div`
padding:8px;
display:flex;
justify-content:space-between;
align-items:center;
border-bottom: 1px solid #e1e1e1;
&:hover ${EditIcon} {
    display: block;
  }
`
export const ProjectList = styled.div`
display:flex;
align-items:center;
`
export const FolderIconCss = styled.div`
margin-right:24px;
`
export const TitleContainer = styled.div`
display:flex;
justify-content:space-between;
`
export const InputContainer = styled.div`
min-width: 350px;
padding: 8px 0;
`
export const InputLabel = styled.div`
margin-top: 5px;
margin-bottom: 5px;
`
export const ProjectName = styled.div`
font-weight: 400;
font-size: 15px;
line-height: 18px;
text-transform:capitalize;
color: #000000;
cursor:pointer;
`
export const CocCount = styled.div`
font-weight: 400;
font-size: 13px;
line-height: 16px;
color: #737373;
`
export const TextBoxContainer = styled.div`
margin: 20px 0px 0px -7px;
`
export const TextBoxLeftAlign = styled.div`
margin: 0px 0px 0px -7px;
`
export const ActionIcon = styled.div`
cursor: pointer;
`
export const ButtonAlign = styled.div`
  text-align: right;
  padding-top: 20px;
`
export const ButtonAlignLeft = styled.div`
  text-align: left;
  padding-top: 20px;
`
export const InlineButtonSize = styled.div`
  width: 50%;
`
export const InlineButton = styled.div`
  display: inline-flex;
  width: 100%;
`
export const IconButtonLarge = styled.div`
  font-size: 40px;
`
export const LinkAlignMent = styled.div`
  text-align: right;
`
export const RightAlignButton = styled.div`
  text-align: right;
  padding-bottom: 10px;
`